import React, { memo, type SVGProps } from 'react';

const SvgChinaResidentIdentityCardFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='ChinaResidentIdentityCardFront_svg__icon'
    viewBox='0 0 1024 1024'
    {...props}
  >
    <path
      fill='#F5F7FA'
      d='M29 201h966c13 0 23 11 23 23v576c0 12-10 23-23 23H29c-13 0-23-11-23-23V224c0-12 10-23 23-23z'
    />
    <path fill='#FEE9E8' d='M809 573v-44H700v44l55 49 54-49' />
    <path
      fill='#EDF1F6'
      d='m893 601-74-17-3-1-60 34-58-35-6 2-73 17c-11 3-19 12-19 23v46c0 7 6 12 12 12h287c7 0 12-5 12-12v-46c0-11-7-20-18-23'
    />
    <path fill='#F5DDDD' d='M700 532v44c68 24 109-36 109-36v-7H700' />
    <path
      fill='#FEE'
      d='m683 401 5 109c0 11 6 20 14 26l24 17c6 5 14 7 20 7h23c9 0 15-2 21-7l24-17c8-6 14-15 14-26l5-109H683'
    />
    <path
      fill='#E3E9F0'
      d='m642 643-37-35c-3 5-5 9-5 15v46c0 6 5 12 12 12h40v-16c0-8-3-16-10-22m225 0 39-35c4 5 6 9 5 15v46c0 7-6 12-12 12h-41v-16c0-8 4-16 9-22'
    />
    <path fill='#C7CDE5' d='M771 682h-31l3-52h23l5 52' />
    <path fill='#C7CDE5' d='M771 617h-31v12c0 3 3 7 6 7h18c3 0 7-4 7-7v-12' />
    <path
      fill='#E3E9F0'
      d='m700 570 56 49c-13 7-24 13-35 23-3 2-8 2-11-2l-1-1-26-55 8-11c3-5 6-5 9-3-1-1-1-1 0 0m110 0-55 49c12 7 24 13 34 23 3 2 8 2 12-2l1-1 25-55-8-11c-2-5-6-5-9-3 0-1 0-1 0 0'
    />
    <path
      fill='#666'
      d='M816 363c-9-11-27-24-61-23-25 0-50 6-72 15l9 6a89 89 0 0 0-32 79c12 12 12 42 12 42l11-12s-4-34 19-47c20-11 39-6 57-6 21 0 35-3 45-8 18 11 22 43 22 53l2 6 11 15c-2-15 2-30 11-42 0-1 3-71-34-78zm-133-9z'
    />
    <path
      fill='#666'
      d='M680 410c-4-17 1-35 12-50-39 30-32 79-32 79 12 12 12 42 12 42l11-12s-4-34 17-47 40-6 58-6l22-1c-38 0-60-29-100-5'
    />
    <path fill='#FEE' d='m668 477 7 27c1 3 6 5 9 4s5-3 5-6l3-26c2-7-4-13-11-14h-1c-7 0-13 5-13 12l1 3' />
    <path fill='#E3E9F0' d='M834 668h-42c-3 0-5 4-5 7v7h54v-7c-1-3-4-6-7-7' />
    <path
      fill='#EDEFF2'
      d='M121 351h66v66h-66v-66zm0 164h368v47H121v-47zm0 116h254v47H121v-47zm94-280h67v66h-67v-66zm93 0h67v66h-67v-66z'
    />
    <path fill='#FEE' d='m847 481-7 26c-1 3-6 6-10 5-2-2-4-4-4-6l-4-27c-1-6 5-12 12-13h1c7 0 13 4 13 11l-1 4' />
  </svg>
);
const Memo = memo(SvgChinaResidentIdentityCardFront);
export default Memo;
